// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"92f037d6","769":"6be351a1"}[chunkId] + ".chunk.css";
};